import { alphabetical, isArray, isEmpty, sift, unique } from "radash";

// initialIds could be archived, so this handles merging them in, uniquly
export const getSelectOptions = ({
  store,
  filter,
  initialIds,
  labelKey = "name",
  labelKeyMap,
  sortAlphabetical = true,
  includeArchived = false,
  groupBy,
} = {}) => {
  initialIds = isArray(initialIds) ? initialIds : [initialIds];
  initialIds = sift(initialIds);

  let options = store.all({ includeArchived });

  if (filter) {
    options = options.filter(filter);
  }

  options = options.map((entity) => ({
    entity,
    value: entity._id,
    label: labelKeyMap ? labelKeyMap(entity) : entity[labelKey],
  }));

  if (!isEmpty(initialIds)) {
    options = unique(
      [...options, ...store.optionsByIds(initialIds)],
      ({ value }) => value
    );
  }

  options = sortAlphabetical ? alphabetical(options, (o) => o.label) : options;

  if (groupBy) {
    return groupBy(options);
  }

  return options;
};
